<template>
  <div class="section6-container">
    <h1 class="content-container title">
      {{ $t("home.s6.t1") }}
    </h1>
    <SwiperComponent />
  </div>
</template>

<script>
export default {
  components: {
    SwiperComponent: () => import("../../../components/Swiperslide.vue")
  }
};
</script>

<style lang="less" scoped>
.section6-container {
  padding: 50px 0px;
}
@media (max-width: 500px) {
  .title {
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(38, 38, 38, 1);
    line-height: 25px;
  }
}

@media (min-width: 501px) {
  .title {
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(38, 38, 38, 1);
    line-height: 50px;
  }
}
</style>
